<template>
  <div
    class="modal fade"
    id="modal_passo_a_passo"
    ref="modal_passo_a_passo"
    tabindex="-1"
    role="dialog"
    aria-labelledby="Tutorial"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header" style="background-color: #ffc107 !important">
          <h5 class="modal-title" style="color: #8a4b08">
            Tutorial rápido! Veja como anunciar produtos!
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Fechar"
            @click="cacheTutorial"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" align="justify-content-center">
          <div class="modal-body" align="center">
            <img src="img/passo_a_passo_produtor01.png" width="100%" />
            <br /><br />
            <img src="img/passo_a_passo_produtor02.png" width="100%" />
            <br /><br />
            <img src="img/passo_a_passo_produtor03.png" width="100%" />
            <br /><br />
            <img src="img/passo_a_passo_produtor04.png" width="100%" />
            <br /><br />
            <img src="img/passo_a_passo_produtor05.png" width="100%" />
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions(["setTutorialCache"]),
    cacheTutorial() {
      this.setTutorialCache();
    },
  },
};
</script>
